"use client";

import {useRouter} from "next/navigation";
import {HeroUIProvider} from "@heroui/react";
import {ToastProvider} from "@heroui/toast";
import {GregorianCalendar} from "@internationalized/date";
import {NuqsAdapter} from "nuqs/adapters/next/app";

interface ProvidersProps {
  children: React.ReactNode;
  locale: string;
}

declare module "@react-types/shared" {
  interface RouterConfig {
    routerOptions: NonNullable<Parameters<ReturnType<typeof useRouter>["push"]>[1]>;
  }
}

export function Providers({children, locale}: Readonly<ProvidersProps>) {
  const router = useRouter();

  return (
    <NuqsAdapter>
      <HeroUIProvider
        createCalendar={() => new GregorianCalendar()}
        locale={locale}
        navigate={router.push}
      >
        <ToastProvider />
        {children}
      </HeroUIProvider>
    </NuqsAdapter>
  );
}
